/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientEmployeeFileUploadFieldsFragment = { __typename: 'ClientEmployeeFileUploadType', id: string, fileName: string, mimetype: string, uploadSize: number, datetime: string, application?: { __typename: 'ClientApplicationType', id: string, resource: { __typename: 'ApplicationResourceType', id: string, publicResource: { __typename: 'ResourceType', id: string, productName?: string | null, vendorName?: string | null, signedLogoUrl?: string | null } } } | null, employee?: { __typename: 'ClientEmployeeType', id: string, name: string, email: string } | null };

export type GetClientEmployeeFileUploadsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  sortBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  clientId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  employeeId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  applicationId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  fileName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  mimetype?: Types.InputMaybe<Types.Scalars['String']['input']>;
  datetime_Gte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  datetime_Lte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type GetClientEmployeeFileUploadsQuery = { __typename: 'Query', clientEmployeeFileUploads?: { __typename: 'ClientEmployeeFileUploadTypeConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ClientEmployeeFileUploadTypeEdge', cursor: string, node?: { __typename: 'ClientEmployeeFileUploadType', id: string, fileName: string, mimetype: string, uploadSize: number, datetime: string, application?: { __typename: 'ClientApplicationType', id: string, resource: { __typename: 'ApplicationResourceType', id: string, publicResource: { __typename: 'ResourceType', id: string, productName?: string | null, vendorName?: string | null, signedLogoUrl?: string | null } } } | null, employee?: { __typename: 'ClientEmployeeType', id: string, name: string, email: string } | null } | null } | null> } | null };


export const ClientEmployeeFileUploadFieldsFragmentDoc = `
    fragment ClientEmployeeFileUploadFields on ClientEmployeeFileUploadType {
  id
  fileName
  mimetype
  uploadSize
  datetime
  application {
    id
    resource {
      id
      publicResource {
        id
        productName
        vendorName
        signedLogoUrl
      }
    }
  }
  employee {
    id
    name
    email
  }
}
    `;
export const GetClientEmployeeFileUploadsDocument = `
    query GetClientEmployeeFileUploads($first: Int, $after: String, $offset: Int, $sortBy: String, $clientId: UUID, $employeeId: UUID, $applicationId: UUID, $fileName: String, $mimetype: String, $datetime_Gte: DateTime, $datetime_Lte: DateTime) {
  clientEmployeeFileUploads(
    first: $first
    after: $after
    offset: $offset
    sortBy: $sortBy
    clientId: $clientId
    employeeId: $employeeId
    applicationId: $applicationId
    fileName_Icontains: $fileName
    mimetype_Icontains: $mimetype
    datetime_Gte: $datetime_Gte
    datetime_Lte: $datetime_Lte
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        ...ClientEmployeeFileUploadFields
      }
    }
  }
}
    ${ClientEmployeeFileUploadFieldsFragmentDoc}`;

export const useGetClientEmployeeFileUploadsQuery = <
      TData = GetClientEmployeeFileUploadsQuery,
      TError = unknown
    >(
      variables?: GetClientEmployeeFileUploadsQueryVariables,
      options?: Omit<UseQueryOptions<GetClientEmployeeFileUploadsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetClientEmployeeFileUploadsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetClientEmployeeFileUploadsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetClientEmployeeFileUploads'] : ['GetClientEmployeeFileUploads', variables],
    queryFn: fetcher<GetClientEmployeeFileUploadsQuery, GetClientEmployeeFileUploadsQueryVariables>(GetClientEmployeeFileUploadsDocument, variables),
    ...options
  }
    )};

useGetClientEmployeeFileUploadsQuery.getKey = (variables?: GetClientEmployeeFileUploadsQueryVariables) => variables === undefined ? ['GetClientEmployeeFileUploads'] : ['GetClientEmployeeFileUploads', variables];

export const useInfiniteGetClientEmployeeFileUploadsQuery = <
      TData = InfiniteData<GetClientEmployeeFileUploadsQuery>,
      TError = unknown
    >(
      variables: GetClientEmployeeFileUploadsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetClientEmployeeFileUploadsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetClientEmployeeFileUploadsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetClientEmployeeFileUploadsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetClientEmployeeFileUploads.infinite'] : ['GetClientEmployeeFileUploads.infinite', variables],
      queryFn: (metaData) => fetcher<GetClientEmployeeFileUploadsQuery, GetClientEmployeeFileUploadsQueryVariables>(GetClientEmployeeFileUploadsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetClientEmployeeFileUploadsQuery.getKey = (variables?: GetClientEmployeeFileUploadsQueryVariables) => variables === undefined ? ['GetClientEmployeeFileUploads.infinite'] : ['GetClientEmployeeFileUploads.infinite', variables];


useGetClientEmployeeFileUploadsQuery.fetcher = (variables?: GetClientEmployeeFileUploadsQueryVariables) => fetcher<GetClientEmployeeFileUploadsQuery, GetClientEmployeeFileUploadsQueryVariables>(GetClientEmployeeFileUploadsDocument, variables);
